import styled from "styled-components";

const LeftGradientDiv = styled.div`
    background: rgb(188,198,228);
    background: -moz-linear-gradient(270deg, rgba(188,198,228,1) 0%, rgba(255,255,255,1) 100%);
    background: -webkit-linear-gradient(270deg, rgba(188,198,228,1) 0%, rgba(255,255,255,1) 100%);
    background: linear-gradient(270deg, rgba(188,198,228,1) 0%, rgba(255,255,255,1) 100%);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#bcc6e4",endColorstr="#ffffff",GradientType=1);
    padding-top : 10px !important;
    padding-bottom : 10px !important;
`

const RightGradientDiv = styled.div`
    background: rgb(188,198,228);
    background: -moz-linear-gradient(90deg, rgba(188,198,228,1) 0%, rgba(255,255,255,1) 100%);
    background: -webkit-linear-gradient(90deg, rgba(188,198,228,1) 0%, rgba(255,255,255,1) 100%);
    background: linear-gradient(90deg, rgba(188,198,228,1) 0%, rgba(255,255,255,1) 100%);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#bcc6e4",endColorstr="#ffffff",GradientType=1);
    padding-top : 10px !important;
    padding-bottom : 10px !important;
`

function WhySell() {

    const content = [
        {
            image : '/SellerHome/GlobalMarketting.png',
            heading : 'Global Marketing',
            description : 'Reach verified buyers from around the world and expand your reach. We will market your products to buyers on your behalf and share direct inquiries with you. We will provide international regulatory, financing, and logistics support to you.'
        },
        {
            image : '/SellerHome/Payments.png',
            heading : 'Hassle-Free Payments',
            description : 'Reach verified buyers from around the world and expand your reach. We will market your products to buyers on your behalf and share direct inquiries with you. We will provide international regulatory, financing, and logistics support to you.'
        },
        {
            image : '/SellerHome/Sales.png',
            heading : 'Making Sales Easier',
            description : 'Group buying deals will help in booking advanced orders. A simple dashboard and one point of contact (apidrug.com) will improve the productivity of your sales team massively. At the same time also allows you to monitor the market response of your products and prices.'
        },
    ]

    return (
        <div className="my-5 lg:pb-[80px]">
            <h1 className="text-theme-blue text-[27px] lg:mb-4 lg:text-4xl --align"> Why sell on apidrug.com ? </h1>
            <p className="text-theme-blue font-light --align"> <span className="underline underline-offset-2">APIdrug.com</span> is free to register. List your products today to start receiving direct inquiries and market intelligence.</p>

            <div>
                {
                    content.map((data : any, index : number) => (
                        <div key={index} className={`mt-10 md:flex items-center ${index % 2 !== 0 && 'md:flex-row-reverse'}`}>
                            <div className={`
                                    w-[60%] 
                                    mx-auto ${index % 2 === 0 ? 'md:ml-[30px] lg:ml-[90px]' : 'md:mr-[30px] lg:mr-[90px]'}
                                    lg:w-[15%]
                                `}>
                                <img className="w-full" src={data.image} alt="" style={{height : 'inherit'}} />
                            </div>

                            {
                                index % 2 === 0 
                                ?
                                <LeftGradientDiv className="--align my-2 md:my-0 lg:w-[70%] lg:h-[190px] flex flex-col justify-center">
                                    <h3 className="text-[#243868] font-semibold text-xl mb-5"> <span className="text-2xl"> {index + 1}. </span> { data.heading } </h3>
                                    <p className="font-light text-theme-blue"> { data.description } </p>
                                </LeftGradientDiv>
                                :
                                <RightGradientDiv className="--align my-2 md:my-0 lg:w-[70%] lg:h-[190px] flex flex-col justify-center">
                                    <h3 className="text-[#243868] font-semibold text-xl mb-5"> <span className="text-2xl"> {index + 1}. </span> { data.heading } </h3>
                                    <p className="font-light text-theme-blue"> { data.description } </p>
                                </RightGradientDiv>
                            }
                        </div>
                    ))
                }
            </div>
        </div>
    )
}

export default WhySell